import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import BackgroundMixTranslateViewModel from "./backgroundMixTranslateViewModel";
import BackgroundMixResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundMixResponse";
import UpdateBackgroundMixRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/UpdateBackgroundMixRequest";

export default class CreateBackgroundMixViewModel {
	id: number = 0;
	animationId: string = null;
	translations: Array<BackgroundMixTranslateViewModel> = [];
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	backFilesIds: Array<string> = [];

	animationUrl: string = null;

	toServerModel(): UpdateBackgroundMixRequest {
		const req = new UpdateBackgroundMixRequest({
			Id: this.id,
			AnimationId: this.animationId,
			BackImage: mapToCropRequest(this.backgroundImage),
			CoverImage: mapToCropRequest(this.coverImage),
			Translations: (this.translations || []).map(x => x.toServerModel()),
			BackgroundFileIds: this.backFilesIds
		});
		return req;
	}

	initLanguages(langs: string[]) {
		this.translations = langs.map(x => new BackgroundMixTranslateViewModel({
			langCode: x
		}));
	}

	fromServerModel(model: BackgroundMixResponse) {
		this.id = model.Id;
		this.backgroundImage.ImageUrl = model.BackImageUrl;
		this.coverImage.ImageUrl = model.CoverImageUrl;
		this.animationId = model.AnimationId;
		this.backFilesIds = model.BackgroundFiles?.map(x=> x.Id) ?? [];

		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x => x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
				tr.id = serverTranslation.Id;
				tr.description = serverTranslation.Description;
			}
		});
	}
}
